module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "linkbar-wrapper"
  }, [_c('el-menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark",
      "default-active": _vm.activeId,
      "background-color": "#304156",
      "text-color": "#fff",
      "active-text-color": "#1890ff"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "admin-title"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.btnCode.btn100001),
      expression: "btnCode.btn100001"
    }],
    staticStyle: {
      "float": "right",
      "margin-right": "30px",
      "color": "#fff",
      "font-size": "14px",
      "line-height": "58px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("待审核消息" + _vm._s(_vm.num))])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6fec1086", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fec1086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Linkbar.vue
// module id = 316
// module chunks = 88